module.exports = __webpack_public_path__ + "static/media/SB1.6280b790.png";